/**
 * Duas decisões da LISTAGEM de chamados, fora da página (pontos 23 e 28).
 *
 * `TicketPage` tem milhares de linhas e nenhum teste. Estas duas regras são
 * pequenas, foram pedidas explicitamente e já falharam em silêncio uma vez --
 * então moram aqui, onde dá para prendê-las.
 */

/**
 * O estilo de uma célula de texto da listagem.
 *
 * ## O `nowrap` é a regra, não um detalhe
 *
 * A reticência estava na listagem desde sempre e NUNCA funcionou:
 * `textOverflow: ellipsis` só age sobre texto que não quebra. Sem o `nowrap`,
 * o assunto quebrava em duas linhas, a reticência nunca aparecia, e a altura
 * da linha variava de chamado para chamado.
 *
 * Quem denunciava a intenção original era o `Tooltip` em volta do assunto: ele
 * existe para mostrar o texto inteiro, o que só faz sentido se o texto estiver
 * cortado.
 *
 * Pedido da Gisele (ponto 23, 20/10/2026): "alargar as informações da listagem
 * para a descrição não quebrar em duas linhas à toa".
 */
export const estiloDeCelula = (fontSize) => ({
    fontSize,
    lineHeight: 1.2,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});

/**
 * A marca de tipo do chamado na listagem: só a EXCEÇÃO.
 *
 * Ponto 28 da Gisele (20/10): "melhorar o espaço de visualização da lista".
 *
 * A listagem escrevia "Público" numa segunda linha em TODO chamado -- metade
 * da altura útil de cada linha gasta repetindo o caso comum. Marcar só o
 * interno devolve essa linha e faz a palavra saltar aos olhos justamente
 * quando ela muda alguma coisa.
 *
 * O dado não se perde: continua na coluna "Tipo", na busca, na exportação e na
 * tela do chamado.
 *
 * @returns {string|null} o rótulo a mostrar, ou nulo quando não há o que dizer
 */
export const marcaDeTipo = (chamado) => (chamado?.is_internal ? 'Interno' : null);
